import { buildPublicationUrl } from "./urlBuilder.js";

export function pageLayout(page = {}) {
  return page.pageLayout || (page.slug === "surgedome" ? "surgedome" : "standard");
}

export function externalPageUrl(value) {
  if (value == null || value === "") return null;
  if (typeof value !== "string") throw new Error("Enter a complete external URL starting with https://.");
  const text = value.trim();
  if (!text) return null;
  if (text.length > 2048 || /[\s\u0000-\u001f\u007f\\]/.test(text) || !/^https?:\/\//i.test(text)) throw new Error("Enter a valid external URL starting with http:// or https:// (up to 2,048 characters).");
  let url;
  try { url = new URL(text); } catch { throw new Error("Enter a complete external URL starting with https://."); }
  if (!["https:", "http:"].includes(url.protocol) || url.username || url.password) throw new Error("Only http:// or https:// page destinations are supported.");
  return url.href;
}

export function validatePageDestination(value, publication, slug) {
  const destination = externalPageUrl(value);
  if (!destination) return null;
  const url = new URL(destination);
  const localPath = `/p/${slug}`;
  const editionPath = buildPublicationUrl({ publication, path: localPath });
  const hosts = [publication.primaryDomain, publication.previewDomain, publication.devDomain].filter(Boolean).map(host => {
    try { return new URL(host.includes("://") ? host : `https://${host}`).host.toLowerCase().replace(/^www\./, ""); } catch { return ""; }
  });
  if (hosts.includes(url.host.toLowerCase().replace(/^www\./, "")) && [localPath, editionPath].includes(url.pathname.replace(/\/$/, ""))) {
    throw new Error("The destination cannot point back to this same page.");
  }
  return destination;
}

export function pageHref(page, settings = {}) {
  // Invalid legacy data must not create executable or broken links.
  try { if (page.externalUrl) return externalPageUrl(page.externalUrl); } catch { /* Use the local page. */ }
  return buildPublicationUrl({ publication: { settings }, path: `/p/${encodeURIComponent(page.slug)}` });
}

export function pageLogoUrl(value) {
  if (value == null || value === "") return null;
  if (typeof value !== "string" || value.length > 2048 || /[\s\\]/.test(value)) throw new Error("Choose a valid logo image.");
  if (/^\/(?!\/)/.test(value)) return value;
  return externalPageUrl(value);
}
